export default "__VITE_ASSET__CGPfL0Gc__"